import { FC, useEffect, useState } from 'react';
import Slider from 'react-slick';
import { Tr } from '@utils';
import { Stack, Tab, Tabs } from '@mui/material';
import { PortalPageTitle } from '@components/portal/common';
import { AdminDashboardDiagnostics, AdminDashboardNotAcceptedUsers, AdminDashboardStatistics } from '@components/portal/admin-dashboard';
import { AdminDashboardTab } from '@models/dashboard';

export const AdminDashboard: FC = () => {
	const [selectedTab, setSelectedTab] = useState<AdminDashboardTab>(AdminDashboardTab.DIAGNOSTICS);
	const [sliderRef, setSliderRef] = useState<Slider>();

	useEffect(() => {
		if (sliderRef) {
			try {
				const index = Object.values(AdminDashboardTab).findIndex((type) => type === selectedTab);
				sliderRef?.slickGoTo(index >= 0 ? index : 0);
			}
			catch {
				// noop
			}
		}
	}, [selectedTab, sliderRef]);

	return (
		<Stack
			direction="column"
			spacing={4}
			sx={{ position: 'relative', height: 1.0, maxHeight: 1.0, paddingX: 9, paddingY: 5, overflowY: 'auto' }}
		>
			<PortalPageTitle title={<Tr.Portal path="admin-dashboard.title" />} subtitle={<Tr.Portal path="admin-dashboard.subtitle" />} />

			<Stack direction="column" spacing={3} sx={{ flexGrow: 1, width: 1.0 }}>
				<Tabs
					value={Object.values(AdminDashboardTab).includes(selectedTab) ? selectedTab : AdminDashboardTab.DIAGNOSTICS}
					onChange={(_e, val) => setSelectedTab(val as AdminDashboardTab)}
					centered
				>
					<Tab value={AdminDashboardTab.OVERVIEW} label={<Tr.Portal path="admin-dashboard.tab-overview" />} />
					<Tab value={AdminDashboardTab.DIAGNOSTICS} label={<Tr.Portal path="admin-dashboard.tab-diagnostics" />} />
					<Tab value={AdminDashboardTab.NOT_ACCEPTED_USERS} label={<Tr.Portal path="admin-dashboard.tab-not-accepted-users" />} />
				</Tabs>

				<Slider
					ref={(ref) => ref && !sliderRef && setSliderRef(ref)}
					dots={false}
					arrows={false}
					draggable={false}
					infinite
					adaptiveHeight
					speed={500}
					slidesToShow={1}
					slidesToScroll={1}
				>
					<AdminDashboardStatistics />
					<AdminDashboardDiagnostics />
					<AdminDashboardNotAcceptedUsers />
				</Slider>
			</Stack>
		</Stack>
	);
};
